const Ripple = ({size}) => (
    <span 
        class="ripple"
        style={{
            width: size * 3,
            height: size * 3
        }}
    />
)
const RedDot = ({ 
    size = 7, 
    color, 
    style = {},
    className = '', 
    ariaLabel,
    pulsing 
}) => (
    <span
        style={{
            display: 'inline-block',
            width: size,
            height: size,
            minWidth: size,
            minHeight: size,
            borderRadius: '50%',
            ...style,
            ...(color ? { backgroundColor: color } : {}),
            verticalAlign: 'middle',
        }}
        className={`red-dot ${className} ${pulsing ? 'pulsing' : ''}`}
        aria-label={ariaLabel}
    >
        {
            pulsing && 
            <>
                <Ripple size={size} />
                <Ripple size={size} />
            </>
        }
    </span>
);

export { RedDot };